import React from 'react';

/* ── Inline Feather-style SVG icons (24x24 viewBox, 2px stroke) ────
   Shared between Header.js and pages that need the same icon set.
   Inlined so we ship no icon library and avoid an extra request. */
const Icon = ({ d, size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {d}
  </svg>
);

// Feather "trash-2": lid with handle, bin with two vertical strokes.
export const IconTrash = (p) => (
  <Icon
    {...p}
    d={
      <>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      </>
    }
  />
);

// Feather "message-circle" with a small "send" feel via the tail.
// Used on the receipt-detail "Send via WhatsApp" button. Generic
// chat-bubble icon rather than WhatsApp-branded so it doesn't look
// out of place if the operator later switches delivery channel.
export const IconWhatsApp = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </>
    }
  />
);

// Feather "alert-triangle": warning icon, useful for destructive modals.
export const IconAlertTriangle = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </>
    }
  />
);

// Feather "edit-2": pencil icon for the "Edit payer info" button.
export const IconEdit = (p) => (
  <Icon
    {...p}
    d={
      <>
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" />
      </>
    }
  />
);